import { AxiosInstance, AxiosProgressEvent } from "axios";
import { APIResponse } from "@/core/types/api";

export interface UploadResponse {
    url: string;
    publicId: string;
    resourceType: string;
}

export function uploadService(api: AxiosInstance) {
    const uploadFile = async (
        file: string,
        resourceType: "image" | "video" | "auto" = "auto",
        onProgress?: (percent: number) => void,
    ): Promise<UploadResponse> => {
        const res = await api.post<APIResponse<UploadResponse>>(
            "/upload",
            { file, resourceType },
            {
                onUploadProgress: (event: AxiosProgressEvent) => {
                    if (onProgress && event.total) {
                        onProgress(Math.round((event.loaded / event.total) * 100));
                    }
                },
            },
        );

        if (!res.data.success || !res.data.data) {
            throw new Error(res.data.error || "Upload failed");
        }

        return res.data.data;
    };

    return {
        uploadFile,
        uploadMultiple: async (
            files: string[],
            resourceType: "image" | "video" | "auto" = "auto",
            onProgress?: (percent: number) => void,
        ) => {
            const percentByFile = new Array(files.length).fill(0);

            const reportAggregate = () => {
                if (!onProgress) return;
                const total = percentByFile.reduce((sum, p) => sum + p, 0);
                onProgress(Math.round(total / files.length));
            };

            return Promise.all(
                files.map((file, index) =>
                    uploadFile(file, resourceType, (percent) => {
                        percentByFile[index] = percent;
                        reportAggregate();
                    }),
                ),
            );
        },
    };
}
